import * as Backbone from "backbone";
import * as _ from "lodash";


interface DashboardWidgetParam {
    key: string,
    value: number
}

interface DashboardWidgetRecord {
    created: number;
    dashboard_category_id: number;
    dashboard_id: number;
    dashboard_widget_type_id: number;
    id: number;
    modified: number;
    order: number;
    params: DashboardWidgetParam[],
    type: string
    app_type: number;

}


export class DashboardWidget extends Backbone.Model {
    attributes: DashboardWidgetRecord;

    url = (): string => {
        const id = this.get('id');
        if (!id) {
            const baseUrl = (Backbone.Model.prototype as any).url.call(this);
            return typeof baseUrl === 'string' ? baseUrl : '';
        }

        const collection = this.collection as any;
        // When not in a collection (e.g. postSave() second save after fetch() replaced models), build url from dashboard_id
        if (!collection) {
            const dashboardId = this.get('dashboard_id');
            if (dashboardId) {
                return '/api/v1/dashboards/' + dashboardId + '/widgets/' + id;
            }
            const baseUrl = (Backbone.Model.prototype as any).url.call(this);
            return typeof baseUrl === 'string' ? baseUrl : '';
        }

        // Build URL with widget ID in path before query parameters
        const baseUrl = collection.url();
        const queryIndex = baseUrl.indexOf('?');
        let url: string;

        if (queryIndex !== -1) {
            url = baseUrl.substring(0, queryIndex) + '/' + id + baseUrl.substring(queryIndex);
        } else {
            url = baseUrl + '/' + id;
        }

        return url;
    }

    getParamValue(key, _default) {
        var param = <DashboardWidgetParam> _.find(this.get('params'), {key: key});

        return param ? param.value : _default;
    }

    setParamValue(key, value) {
        var param = <DashboardWidgetParam> _.find(this.get('params'), {key: key});

        if (param) {
            param.value = value;
        } else {
            this.get('params').push({key: key, value: value});
        }
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/models/DashboardWidget.ts